export default {
  language: '言語',
  addMultiLang: '多言語を追加',
  delete: '削除',
  save: '保存',
  addMultiLangModalTitle: '会員多言語情報',
  deleteMultiLangModalTitle: '多言語を削除',
  selectLangWarning: '少なくとも1つの言語を選択してください',
  addLangSuccess: '言語が正常に追加されました',
  deleteLangSuccess: '言語が正常に削除されました',
  deleteLangFailed: '言語の削除に失敗しました',
  contentRequired: 'アフターサービスフィードバックの内容を入力してください',
  saveSuccess: '正常に保存されました',
  saveFailed: '保存に失敗しました',
  loadFailed: 'アフターサービスフィードバック内容の読み込みに失敗しました',
  placeholder: 'アフターサービスフィードバックの内容を入力してください',
};
